import { generateRandomId } from "../../edd/utils/utils";
const isExists = (state, search) =>
  state.some(element => convertToLowerCase(element.label) === convertToLowerCase(search.label));

const convertToLowerCase = value => value.toLowerCase();

function recentSearches(state = [], action) {
  switch (action.type) {
    case 'ADD_RECENT_SEARCH':
      if (action.search.label && isExists(state, action.search)) {
        let existSearch = state.filter(
          element => convertToLowerCase(element.label) === convertToLowerCase(action.search.label)
        );
        let oldSearch = state.filter(
          element => convertToLowerCase(element.label) !== convertToLowerCase(action.search.label)
        );
        return [...oldSearch, ...existSearch];
      }
      return [
        ...state,
        {
          image: action.search.image,
          label: action.search.label,
          url: action.search.url,
          id: generateRandomId(18)
        }
      ];
    case 'REMOVE_RECENT_SEARCH':
      // eslint-disable-next-line no-case-declarations
      const newState = state.filter(searches => {
        return searches.id !== action.id;
      });
      return [...newState];
    case 'REMOVE_RECENT_SEARCHES':
      // eslint-disable-next-line no-case-declarations
      const newstate = state.filter(searches => !action.searchIds.includes(searches.id));
      return [...newstate];
    default:
      return state;
  }
}

export default recentSearches;
